import axios from "axios";

const calcProgress = (ev) => Math.round((ev.loaded * 100) / ev.total);

export const signAndUpload = async (inputFile, file, dispatchFile) => {
  const signedUrlRes = await axios
    .post("/api/signed_url", {
      fileName: file.name,
      fileType: file.mimetype,
      fileId: file.id,
      acl: file.acl,
      directory: file.directory
    })
    .catch((error) => {
      console.error("s3 signing error", error);
    });

  const signedRequest = signedUrlRes.data.signedRequest;
  file = { ...file, url: signedUrlRes.data.url };

  // Put the fileType in the headers for the upload
  await axios
    .put(signedRequest, inputFile, {
      onUploadProgress: (e) => {
        if (!dispatchFile) return;

        dispatchFile({
          operation: "SET_UPLOAD_PROGRESS",
          file: { ...file, progress: calcProgress(e) }
        });
      },
      headers: { "Content-Type": file.mimetype }
    })
    .catch((error) => {
      console.error("s3 upload error", error);
    });

  return file;
};
